// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InteractiveMap {
  height: 100%;
  padding: 10px;
}
.InteractiveMap__Map {
  width: 100%;
  height: 100%;
  min-height: 70vh;
  display: block;
}

@media screen and (max-width: 768px) {
  ion-card-content {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./libs/features/interactive-map/src/lib/interactive-map/interactive-map.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAGA;EACE;IACE,UAAA;EAAF;AACF","sourcesContent":[".InteractiveMap {\n  height: 100%;\n  padding: 10px;\n\n  &__Map {\n    width: 100%;\n    height: 100%;\n    min-height: 70vh;\n    display: block;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  ion-card-content {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
